<app-button *ngIf="!record_exists" (click)="sendForKYCWork()" class="small outline mt-3" style="margin-left: 10px;"
  label="Send For KYC"></app-button>



<app-button *ngIf="record_exists" (click)="checkForKYCWork()" class="small outline mt-3" style="margin-left: 10px;"
  label="Check KYC Status - {{case_id}}"></app-button>